/**
 * LandingFooter — dark footer with brand + copyright.
 */

import { type ReactNode } from 'react'
import { LogoDoor }       from '@/components/brand/LogoDoor'

export function LandingFooter(): ReactNode {
  const year = new Date().getFullYear()
  return (
    <footer className="landing-footer">
      <div className="landing-footer__brand">
        <LogoDoor size={28} />
        <span className="landing-footer__name">ReadyRoomOps</span>
      </div>
      <p className="landing-footer__copy">
        © {year} ReadyRoomOps™. All rights reserved.
      </p>
      <p className="landing-footer__attribution">
        Envisioned by{' '}
        <a
          href="https://envisionvirtualedge.org"
          target="_blank"
          rel="noopener noreferrer"
          className="landing-footer__attribution-link"
        >
          Envision VirtualEdge Group, LLC™
        </a>{' '}
        · © {year}
      </p>
    </footer>
  )
}
